// Web-only guard for DOM mutations performed outside React. Two sources hit
// this in production:
// - React's commit-phase deletion of a subtree containing a Radix/Zeego portal
//   whose container is inside (or already detached from) the deleted tree —
//   removeChild throws NotFoundError and crashes to the error boundary
//   (CHURCH-APP-1AV / CHURCH-APP-1BE).
// - Browser translate/extensions mutating text nodes under React-managed DOM.
// The child is already gone, which is the desired end state — tolerating the
// no-op keeps the commit phase intact instead of throwing.
const installDomMutationGuard = () => {
    if (typeof Node !== 'function' || !Node.prototype) return;

    const originalRemoveChild = Node.prototype.removeChild;
    Node.prototype.removeChild = function (child) {
        if (child.parentNode !== this) {
            console.warn('Ignored removeChild of a node that is not a child of this parent', child, this);
            return child;
        }
        return originalRemoveChild.apply(this, arguments);
    };

    const originalInsertBefore = Node.prototype.insertBefore;
    Node.prototype.insertBefore = function (newNode, referenceNode) {
        if (referenceNode && referenceNode.parentNode !== this) {
            console.warn('Ignored insertBefore of a reference node that is not a child of this parent', newNode, referenceNode, this);
            return newNode;
        }
        return originalInsertBefore.apply(this, arguments);
    };
};

export default installDomMutationGuard;
